import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarBanco, setModalDeletarBanco } from "../redux/slices/banco/bancoSlice";

export const cadastrarBanco = createAsyncThunk("/Banco/CadastrarBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Banco/CadastrarBanco", payload.value);
    toastSucess("Banco cadastrado com sucesso");
    dispatch(setModalCadastrarBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarBanco = createAsyncThunk("/Banco/BuscarBanco", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/Banco/BuscarBanco", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarBanco = createAsyncThunk("/Banco/AtualizarBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Banco/AtualizarBanco", payload.value);
    toastSucess("Banco atualizado com sucesso");
    dispatch(setModalCadastrarBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarBancoAtivo = createAsyncThunk("/Banco/AtualizarBancoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Banco/AtualizarBancoAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo do banco foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarBanco = createAsyncThunk("/Banco/DeletarBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Banco/DeletarBanco", {
      params: { id: payload.value },
    });
    toastSucess("Banco removido com sucesso");
    dispatch(setModalDeletarBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
